<template>
  <div class="clm-form__line name" :class="classObj">
    <div class="clm-form__input">
      <div class="clm-form__label-block">
        <label :for="id" class="clm-label">
          <slot></slot> <sup v-if="isRequared">*</sup>
        </label>
        <button type="button" class="clm-form__mark orange"
                v-if="showPassRecovery"
                @click.prevent="$emit('recovery')">
          {{$t('auth-form-input.forgotPass')}}
        </button>
      </div>
      <div class="clm-form__block-input">
        <div class="clm-form-icon">
          <div class="clm-icon-password" v-if="showPassBtn">
            <button type="button" class="clm-icon-password__show" @click.prevent="$emit('pass:show')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0007 3.75C5.83398 3.75 2.27565 6.34167 0.833984 10C2.27565 13.6583 5.83398 16.25 10.0007 16.25C14.1673 16.25 17.7256 13.6583 19.1673 10C17.7256 6.34167 14.1673 3.75 10.0007 3.75ZM10.0007 14.1667C7.70065 14.1667 5.83398 12.3 5.83398 10C5.83398 7.7 7.70065 5.83333 10.0007 5.83333C12.3006 5.83333 14.1673 7.7 14.1673 10C14.1673 12.3 12.3006 14.1667 10.0007 14.1667ZM10.0007 7.5C8.61732 7.5 7.50065 8.61667 7.50065 10C7.50065 11.3833 8.61732 12.5 10.0007 12.5C11.384 12.5 12.5007 11.3833 12.5007 10C12.5007 8.61667 11.384 7.5 10.0007 7.5Z" fill="#E1DAD5"/>
              </svg>
            </button>
            <button type="button" class="clm-icon-password__hide" @click.prevent="$emit('pass:hide')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_207_1626)">
                  <path d="M10.0002 3.75C5.8335 3.75 2.27516 6.34167 0.833496 10C2.27516 13.6583 5.8335 16.25 10.0002 16.25C14.1668 16.25 17.7252 13.6583 19.1668 10C17.7252 6.34167 14.1668 3.75 10.0002 3.75ZM10.0002 14.1667C7.70016 14.1667 5.8335 12.3 5.8335 10C5.8335 7.7 7.70016 5.83333 10.0002 5.83333C12.3002 5.83333 14.1668 7.7 14.1668 10C14.1668 12.3 12.3002 14.1667 10.0002 14.1667ZM10.0002 7.5C8.61683 7.5 7.50016 8.61667 7.50016 10C7.50016 11.3833 8.61683 12.5 10.0002 12.5C11.3835 12.5 12.5002 11.3833 12.5002 10C12.5002 8.61667 11.3835 7.5 10.0002 7.5Z" fill="#E1DAD5"/>
                  <rect x="2.00006" y="0.292893" width="26" height="2" transform="rotate(45 2.00006 0.292893)" fill="#E1DAD5" stroke="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_207_1626">
                    <rect width="20" height="20" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
          <div class="clm-icon-check">
            <div class="clm-icon-check__ok">
              <img src="/local/img/form/form-check.svg" alt="">
            </div>
          </div>
        </div>

        <input v-if="isMaskedPhone" :type="inputType"
               :id="id"
               class="clm-input"
               :placeholder="placeholder"
               :value="modelValue"
               @input="$emit('update:modelValue', $event.target.value)"
               v-maska="'+7 (###) ###-##-##'"
               tabindex="1"
        >
        <input v-else :type="inputType"
               :id="id"
               class="clm-input"
               :placeholder="placeholder"
               :value="modelValue"
               @input="$emit('update:modelValue', $event.target.value)"
               @keyup="onKeyup"
               tabindex="1"
        >
      </div>
      <div class="clm-form__err">
        {{ errMsg }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "auth-form-input",
  props: {
    modelValue: String,
    isValid: {
      type: Boolean,
      default: false,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    isRequared: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    errMsg: String,
    inputType: {
      type: String,
      default: 'text'
    },
    inputName: String,
    id: String,
    className: String,

    showPassBtn: {
      type: Boolean,
      default: false,
    },
    showPassRecovery: {
      type: Boolean,
      default: false,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    isMaskedPhone: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    classObj() {
      const classList = {
        'is-valid' : this.isValid,
        'is-invalid' :  this.isInvalid,
        'is-visible': this.isVisible
      }
      if (this.className) {
        classList[this.className] = true;
      }
      return classList;
    }
  },
  methods: {
    onKeyup(e) {
      if (e.code === 'Enter') {
        this.$emit('submit')
      }
    }
  },
}
</script>
